import { useMutation } from '@tanstack/react-query';

import { submitAttachments } from './app.service';
import { APP_SERVICE_MUTATION_KEYS } from './app.service.constants';

import { TError } from '../api.type';

import { CloudFileDto } from '@/generated-types';

type TSubmitAttachmentsParams = {
	applicationId: string;
	attachments: CloudFileDto[];
};

type TUsePostSubmitAttachmentsResponse = ReturnType<
	typeof useMutation<void, TError, TSubmitAttachmentsParams>
>;

export const usePostSubmitAttachments = (): TUsePostSubmitAttachmentsResponse => {
	return useMutation({
		mutationKey: APP_SERVICE_MUTATION_KEYS.SUBMIT_ATTACHMENTS,
		mutationFn: (params: TSubmitAttachmentsParams) =>
			submitAttachments(params.applicationId, params.attachments),
	});
};
